import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const operationBaseEndpoint = ENDPOINTS.OPERATION;

// Operations API
export const operationsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["operations"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOperations: builder.query({
        query: (payload) => `${operationBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "operations" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addOperations: builder.mutation({
        query: (requestData) => ({
          url:  `${operationBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "operations" }],
      }),
      updateOperations: builder.mutation({
        query: ({id, requestData}) => ({
          url:  `${operationBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "operations" }],
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetOperationsQuery, useAddOperationsMutation, useUpdateOperationsMutation } = operationsApi;
